import { IconButton, Link, Text, useToast } from "@chakra-ui/react";

import ADD_MULTIPLE_ITEMS_TO_CART from "../../types/AddMultipleItemsToCart";
import { MdAdd } from "../../customIcons";
import React from "react";
import { useAppState } from "../../context";
import { useMutation } from "@apollo/client";

const AddToCartBundle: React.FC<{
  productIds: number[];
  name?: string;
  price?: string;
}> = ({ productIds, name, price }) => {
  const toast = useToast();
  const { setCart } = useAppState();

  const [addMultipleItemsToCart, { loading }] = useMutation(
    ADD_MULTIPLE_ITEMS_TO_CART,
    {
      onCompleted: ({ addMultipleItemsToCart }) => {
        setCart(addMultipleItemsToCart.cart);
      },
      onError: () => {
        toast({
          title: "Error",
          description: "There was an error adding your product",
          status: "error",
        });
      },
    },
  );

  const handleAddToCartBundle = async () => {
    try {
      const parsedProducts = productIds.map((item) => ({
        productId: item,
        quantity: 1,
      }));

      await addMultipleItemsToCart({
        variables: {
          items: parsedProducts,
        },
      });

      toast({
        title: (
          <Text>
            Added to&nbsp;
            <Link href="/cart" fontWeight={700} textDecoration="underline">
              cart
            </Link>
          </Text>
        ),
        status: "success",
      });

      window.dataLayer = window.dataLayer || [];

      window.dataLayer.push({
        event: "add_to_cart",
        ecommerce: {
          items: productIds.map((id) => ({
            item_name: name,
            item_id: id,
            price: price ? parseFloat(price.replace("$", "")) : undefined,
            quantity: 1,
          })),
        },
      });
    } catch (e) {
      toast({
        title: "Error",
        description: "There was an error adding your bundle",
        status: "error",
      });
    }
  };

  return (
    <IconButton
      aria-label="button"
      w="32px"
      borderRadius="4px"
      icon={<MdAdd />}
      h="32px"
      bg="#3B2060"
      color="#fff"
      isLoading={loading}
      onClick={handleAddToCartBundle}
      sx={{
        minWidth: "32px",
        minHeight: "32px",
        padding: 0,
        justifyContent: "center",
        alignItems: "center",
      }}
      _hover={{ background: "#6A3AAB" }}
    />
  );
};

export default AddToCartBundle;
